import React from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import badgeGetImage from "../../static/images/badge-get.png";
import checkIcon from "../../static/images/check-green.svg";
import rankupGetImage from "../../static/images/rankup-get.png";
import classes from "./BadgeCard.module.scss";
import RankupIcon from "../../static/images/BeginerRankupIcon.svg";
import { Badge } from "../../api/UsersBadgeApi";

type Props = {
  data: Badge;
};

const BadgeCard = (props: Props) => {
  return (
    <div className={classes.container}>
      <img
        className={classes.image}
        src={props.data.badgeImageData}
        alt={props.data.badgeImageData}
      />
      <div className={classes.title}>{props.data.title}</div>
    </div>
  );
};

export default BadgeCard;
